module.exports = __webpack_public_path__ + "img/slphouse_main9.bf4e7b9e.png";